import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Client } from 'src/app/feature/BNPL/shared/models/client.model';
import { DataInformation } from 'src/app/feature/BNPL/shared/models/data-information.model';
import { Questionarie } from 'src/app/feature/BNPL/shared/models/validation-strategy-response.model';
import { BnplService } from 'src/app/feature/BNPL/shared/services/bnpl.service';
import { IdentityvalidationService } from 'src/app/feature/BNPL/shared/services/identityvalidation.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  public mostrarAlerta: string = 'espera';
  questionarie: Questionarie;
  public dataInformation: DataInformation;
  name: string = ''
  amountFinance: number = 0
  usefunction = localStorage.getItem('fun') ?? 'S'
  urlRedirect: string = ''
  urlPayment: string = environment.urlPayment.url
  public clientSelected!: Client;
  isScreenLarge: boolean = false;
  navigate: any = this.router.getCurrentNavigation()
  dataNavigate: any = {}
  showButton: boolean = true
  navigationExtras: NavigationExtras = {} 

  constructor(
    private readonly bnplService: BnplService,
    private readonly validationStrategyService: IdentityvalidationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.name = this.bnplService.personalInformation.name || this.bnplService.stepsInformation.secondStep.primerNombre || ''
    this.amountFinance = this.bnplService.creditEmit.amountFinance
    this.dataInformation = this.bnplService.personalInformation;
    this.questionarie = this.bnplService.questionarieEmit;
    this.bnplService.clients.subscribe((resp: Client[]) => {
      const [client] = resp.filter(
        (client) => client.id === this.dataInformation.client
      );
      this.clientSelected = client;
    });
    this.dataNavigate = this.navigate.extras.state as {
    };

  }
  ngOnInit(): void {

    Swal.close()
    this.checkScreenSize();
    const params = this.route.snapshot.params['strategy'];
    if (params === 'reconocer') {
      if (this.bnplService.creditEmit.validationStrategy === 'CREDIT_DENIED') {
            this.mostrarAlerta = 'error'
      }

      if (this.bnplService.creditEmit.validationStrategy === 'ERROR') {
            this.mostrarAlerta = 'error'
      }

      if (this.bnplService.creditEmit.validationStrategy === 'ERROR_IDENTITY_VALIDATION') {
            this.mostrarAlerta = 'error'
      }

    }
    if (params === 'espera') {
      let secondStep = this.bnplService.stepsInformation.secondStep
      let data =

      {
        actionStrategyPattern: 'DEFINE_STRATEGY',
        ammount: this.dataInformation.ammount ? this.dataInformation.ammount : +this.bnplService.stepsInformation.thirdStep.monto,
        birthdayDate: `${secondStep.diaNacimiento}/${secondStep.mesNacimiento}/${secondStep.anioNacimiento}`,
        celularFormulario: this.bnplService.stepsInformation.firstStep.celular,
        client: this.dataInformation.client ? this.dataInformation.client : localStorage.getItem('partner'),
        emailFormulario: secondStep.email,
        fechaExpedicion: `${secondStep.dia}/${secondStep.mes}/${secondStep.anio}`,
        fullName: `${secondStep.primerNombre} ${secondStep.primerApellido}`,
        id: this.dataInformation.id ? this.dataInformation.id : null,
        identificacion: this.bnplService.stepsInformation.firstStep.numeroDocumento,
        name: secondStep.primerNombre,
        primerApellido: secondStep.primerApellido,
        referenciaPago: this.dataInformation.referenciaPago ? this.dataInformation.referenciaPago : this.bnplService.stepsInformation.thirdStep.referenciaPago,
        term: this.dataInformation.term ? this.dataInformation.term : +this.bnplService.stepsInformation.thirdStep.numeroCuotas,
        tipoIdentificacion: environment.typeId,
        tipoIdentificacionText: environment.descriptionId,
        direccion: secondStep.direccion,
        googleMaps: secondStep.googleMaps
      }
      
      this.validationStrategyService.getValidationStrategy(data).subscribe({
        next: async (resp: any) => {
          this.navigationExtras = {state: resp}
          if (resp.validationStrategy === 'ERROR_EVIDENTE') {
            // localStorage.setItem('id', resp.id);
            // this.bnplService.questionarieEmit = resp.questionarie;
            // this.router.navigate(['/identity-validation']);
            this.mostrarAlerta = 'evidente';
              this.router.navigate(['await-alert', 'evidente'])
            
          }
          if (resp.validationStrategy === 'RECONOCER') {
            localStorage.setItem('id', resp.id);
            this.router.navigate(['/confirm-otp']);
          }
  
          if (resp.showMessage == 2) {
            if (resp.codigo == '431') {
              this.mostrarAlerta = 'evidente';
              this.router.navigate(['await-alert', 'evidente'])
            } else {
              this.dataNavigate = resp
              this.mostrarAlerta = 'error'
            }
            
          }

          if (resp.errorMessage) {
            this.mostrarAlerta = 'error-connection'
          }
        },
        error: (e: any) => {
          Swal.close();
          this.mostrarAlerta = 'error-connection'
        },
      });
    }

    if (params == 'error') {
      this.mostrarAlerta = 'error'
    }

    if (params == 'error-connection') {
      this.mostrarAlerta = 'error-connection'
    }
    if (params === 'fallo') {
      this.mostrarAlerta = 'fallo';
    }

    if (params === 'identidad') {
      this.mostrarAlerta = 'fallo';
    }

    if (params === 'ultimopaso') {
      this.mostrarAlerta = 'ultimopaso';
    }

    if (params === 'felicidades') {
      this.mostrarAlerta = 'felicidades';
      document.body.style.backgroundColor = '#7dffb2'
    }

    if (params === 'masadelante') {
      this.mostrarAlerta = 'masadelante';
      document.body.style.backgroundColor = '#FFB600'
    }

    if (params === 'nocupo') {
      this.mostrarAlerta = 'nocupo';
    }

    if (params === 'saliomal') {
      this.mostrarAlerta = 'saliomal';
    }

    if (params === 'evidente') {
              this.mostrarAlerta = 'evidente';
              this.router.navigate(['await-alert', 'evidente'])
      // if (localStorage.getItem('preguntas')) {
      //   const preguntas = JSON.parse(localStorage.getItem('preguntas') || "");
      //   let data = {
      //     actionStrategyPattern: 'VALIDATE_STRATEGY',
      //     id: localStorage.getItem('id'),
      //     validationStrategy: {
      //       validationStrategy: 'EVIDENTE',
      //       questionarie: {
      //         cuestionario: this.questionarie.cuestionario,
      //         registroCuestionario: this.questionarie.registroCuestionario,
      //         fecha: 'null',
      //         cliente: {
      //           tipoDocumento: '1',
      //           numeroDocumento: '52916207',
      //           primerNombre: 'null',
      //           primerApellido: 'null',
      //           fechaExpedicionDocumento: 'null',
      //         },
      //         rtaCuestionario: preguntas,
      //         preguntas: [],
      //       },
      //     },
      //   };
      //   this.validationStrategyService.postPreguntasEvidente(data).subscribe({
      //     next: (resp: any) => {
      //     this.navigationExtras = {state: resp}

      //     if (resp.showMessage == 2) {

      //       Swal.close();
      //       this.dataNavigate = resp
      //       this.mostrarAlerta = 'error'
      //     }

      //       if (resp.validationStrategy === 'CREDIT_APPROVED') {
      //         this.bnplService.creditEmit = resp;
      //         this.mostrarAlerta = 'evidente';
      //         this.router.navigate(['await-alert', 'evidente'])
      //       }

      //       if (resp.errorMessage) {
      //         this.mostrarAlerta = 'error-connection'
      //       }


      //     },
      //     error: (e: any) => {
      //       Swal.close();
      //       this.router.navigate(['/await-alert', 'error-connection']);
      //       console.log('error', e)
      //     },
      //   });
      // }
    }

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  executeFunction(event: string) {
      if (event == '1'){
        this.navigateToClient()
      }
      if (event == '2'){
        this.navigateToPayment()
      }
      if (event == '3'){
        this.navigateToEvidente()
      }
  }

  navigateToEvidente(){
    this.router.navigate(['/selection-fees']);
  }
  checkScreenSize() {
    this.isScreenLarge = window.innerWidth > 992;
  }

  navigateToClient() {
    window.location.href = this.dataInformation.urlRedirect;
    localStorage.clear()
    sessionStorage.clear()
  }

  navigateToPayment() {
    window.location.href = this.urlPayment
  }

  navigateToBasicData() {
    this.router.navigate(['/basic-data']);
  }

  useFunction() {
    if (this.usefunction == 'S') {
      this.navigateToDocuments()
    } else if (this.usefunction == 'A') {
      this.navigateToPreApprobe()
    }
  }

  navigateToDocuments() {
    this.bnplService.alertWait()
    this.router.navigate(['/sign-documents']);
  }

  navigateToPreApprobe() {
    this.bnplService.alertWait()
    const data = {
      actionStrategyPattern: 'INFORMATION_CREDIT',
      id: this.bnplService.personalInformation.id || localStorage.getItem('id'),
      ammount: this.bnplService.personalInformation.ammount || localStorage.getItem('ammount'),
      client: this.bnplService.personalInformation.client || localStorage.getItem('partner'),
      term: localStorage.getItem('fees') || ''
    }
    this.bnplService.getCreditCupo(data).subscribe({
      next: (resp: any) => {
      this.navigationExtras = {state: resp}
      
      if (resp != null && resp.validationStrategy == "OK") {
        this.bnplService.creditCupo = resp;
        this.router.navigate(['/summary-credit']);
      }

      if (resp.showMessage == 2) {
        Swal.close();
        this.dataNavigate = resp
            this.mostrarAlerta = 'error'
        // this.router.navigate(['/await-alert', 'error'], this.navigationExtras);
      }

      if (resp.errorMessage) {
        Swal.close();
        this.mostrarAlerta = 'error-connection'
      }
    }, error: (e: any) => {
      Swal.close();
      this.router.navigate(['/await-alert', 'error-connection']);
      console.log('error', e)
    },
  })
  }

  navigateToUseCupo() {
    this.router.navigate(['/usecupo']);
    document.body.style.backgroundColor = '#F7F7F7'
  }

  enableMasAdelante() {
    this.mostrarAlerta = 'masadelante';
    document.body.style.backgroundColor = '#FFB600'
    this.router.navigate(['await-alert', 'masadelante'])
  }

  redirectWhatsapp() {
    const mensaje = encodeURIComponent('Hola, necesito asistencia con mi solicitud de cupo.');
    const telefono = '573164740252';
    window.location.href = `https://wa.me/${telefono}?text=${mensaje}`;
  }

}
